
export const DAU_ROUTES = {
  dau           : 'formulario/atencion/urgencias',
  dauByDate     : 'historial/atenciones/diarias',
  dauDetails    : 'detalles/atencion/urgencias',
  historyPatient: 'historial/paciente',
};
